import { User } from "../../apis/mgmt/api";
import { DataFormWithButtonsLayout } from "../common/DataFormWithButtonsLayout";
import { EditableProps } from "../common/Editable";
import { UserForm } from "./UserForm";


export const UserEditable = function (
    props: EditableProps<User>
) {

    return (
        <DataFormWithButtonsLayout editableProps={props} saveAndStay={true}>
            <UserForm {...props} />
        </DataFormWithButtonsLayout>
    );

};
